function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("rect", {
  y: 0,
  width: 20,
  height: 2
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 6,
  width: 20,
  height: 2
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 12,
  width: 20,
  height: 2
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14"
  }, props), _ref, _ref2, _ref3);
};

export default 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAyMCAxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB5PSIwIiB3aWR0aD0iMjAiIGhlaWdodD0iMiIgLz4KICA8cmVjdCB5PSI2IiB3aWR0aD0iMjAiIGhlaWdodD0iMiIgLz4KICA8cmVjdCB5PSIxMiIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIiIC8+Cjwvc3ZnPgo=';
export { SvgComponent as ReactComponent };